module.exports = __webpack_public_path__ + "img/icon-gis.95ea19ee.png";